import type { Paginated, UnifiedOrderListItem } from '@flux/shared';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api/client.js';
import { queryKeys } from '@/lib/query/keys.js';

/**
 * Badge « Commandes » (`02` §0) : nombre de lignes en erreur ou bloquées,
 * toutes origines confondues — factures Pennylane comprises, puisqu'elles
 * vivent dans la même liste. `pageSize: 1` : seul `total` nous intéresse.
 */
function fetchOrdersAttentionCount(): Promise<number> {
  return apiFetch<Paginated<UnifiedOrderListItem>>('/api/orders/unified', {
    query: { status: ['error', 'blocked'], page: 1, pageSize: 1 },
  }).then((result) => result.total);
}

export function useOrdersAttentionCount(): UseQueryResult<number> {
  return useQuery({
    queryKey: queryKeys.orders.attentionCount(),
    queryFn: fetchOrdersAttentionCount,
    refetchInterval: 30_000,
  });
}
